export enum TagStatusSize {
  XL = 'xl',
  LG = 'lg',
  MD = 'md',
  RG = 'rg',
}

export enum TagStatusType {
  Success = 'success',
  Processing = 'processing',
  Error = 'error',
  Cancelled = 'cancelled',
  Original = 'original',
}
